// FILE PATH: eRFQFrontend/src/component/Vendor/LogisticBidSubmission/LogisticStep1.jsx

import { Box, Button, CircularProgress, Grid2, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { uploadFile } from "../../../utils/uploadToAzure";

const LogisticStep1 = ({ bid, setBid, rfq, setStep, storedUser }) => {

  const navigate = useNavigate();

  const [errors, setErrors] = useState({});

  const [uploading, setUploading] = useState({
    attachment1: false,
    attachment2: false,
    attachment3: false,
  });

  const handleChange = (e) => {

    setBid({
      ...bid,
      [e.target.name]: e.target.value,
    });

    setErrors({
      ...errors,
      [e.target.name]: "",
    });

  };

  const handleFileUpload = async (e) => {

    const { name, files } = e.target;

    if (!files || files.length === 0) return;

    const file = files[0];

    setUploading((prev) => ({
      ...prev,
      [name]: true,
    }));

    setBid((prev) => ({
      ...prev,
      [`${name}Filename`]: file.name,
    }));

    try {

      const url = await uploadFile(
        file,
        "logistics",
        rfq.logisticDraftId,
        storedUser
      );

      setBid((prev) => ({
        ...prev,
        [name]: url,
      }));

      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));

    } catch (error) {

      console.error("Upload failed:", error);

    } finally {

      setUploading((prev) => ({
        ...prev,
        [name]: false,
      }));

    }

  };

  const removeAttachment = (key) => {

    setBid((prev) => ({
      ...prev,
      [key]: "",
      [`${key}Filename`]: "",
    }));

  };

  const handleNext = () => {
    setStep(2);
  };

  const currencyArray = Array.isArray(rfq?.currencies)
    ? rfq.currencies
    : [];

  return (

    <div style={{ position: "relative" }}>

      {/* Buyer RFQ Details */}

      <Box className="dashboard-container" px={10}>

        <Typography className="form-title">
          Logistics RFQ Details
        </Typography>

        <Grid2 container>

          {[

            { label: "Logistics RFQ ID", value: rfq?.logisticDraftId },
            { label: "Mode of Consignment", value: rfq?.modeOfConsignment },
            { label: "Consignee", value: rfq?.consignee },
            { label: "Invoice No", value: rfq?.invoiceNo },

            {
              label: "Transit Time",
              value: rfq?.transitTime
                ? `${rfq.transitTime} Days`
                : "N/A",
            },

            { label: "No of Pallets", value: rfq?.noOfPallets },
            { label: "Address", value: rfq?.address },
            { label: "Origin", value: rfq?.origin },
            { label: "Destination", value: rfq?.destination },

            {
              label: "Gross Weight",
              value: rfq?.grossWeight
                ? `${rfq.grossWeight} KG`
                : "N/A",
            },

            {
              label: "Dimensions (L x B x H)",
              value: `${rfq?.length || 0} x ${rfq?.breadth || 0} x ${rfq?.height || 0} inches`,
            },

            { label: "Volume ", value: rfq?.volumeCBM ? `${rfq.volumeCBM} CBM` : "N/A" },

          ].map((row, idx) => (

            <React.Fragment key={idx}>

              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
                sx={{
                  borderTop:
                    idx === 0
                      ? "1px solid #000"
                      : undefined,
                }}
              >
                {row.label}
              </Grid2>

              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
                sx={{
                  borderRight: "1px solid #000",
                  borderTop:
                    idx === 0
                      ? "1px solid #000"
                      : undefined,
                }}
              >
                {row.value || "-"}
              </Grid2>

            </React.Fragment>

          ))}

        </Grid2>

      </Box>

      {/* Currency Exchange Table */}

      {currencyArray.length > 0 && (

        <>

          <h2>Currency Exchange Rates</h2>

          <Box className="dashboard-container" px={10}>

            <table
              border={1}
              style={{
                borderCollapse: "collapse",
                width: "100%",
                marginTop: "10px",
              }}
            >

              <thead>

                <tr>
                  <th style={{ padding: "20px" }}>
                    Currency
                  </th>
                  <th>Exchange Rate</th>
                </tr>

              </thead>

              <tbody>

                {currencyArray.map((c, idx) => (

                  <tr
                    key={idx}
                    style={{ textAlign: "center" }}
                  >

                    <td style={{ padding: "20px" }}>
                      {c.name}
                    </td>

                    <td>
                      {c.rate}
                    </td>

                  </tr>

                ))}

              </tbody>

            </table>

          </Box>

        </>

      )}

      {/* Buttons */}

      <Box className="btn-container" sx={{ gap: 3 }}>

        <Button
          className="btn-outlined"
          onClick={() =>
            navigate("/vendor/logistic-dashboard")
          }
        >
          Back
        </Button>

        <Button
          className="btn-contained"
          onClick={handleNext}
        >
          Next
        </Button>

      </Box>

    </div>

  );

};

export default LogisticStep1;
